import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import Index from './views/index.vue'
import Product from './views/Product.vue'
import ProductSecond from './views/ProductSecond.vue'
import Information from './views/Information.vue'
import InformationSecond from './views/InformationSecond.vue'
import Kingstron from './views/Kingstron.vue'
import KingstronSecond from './views/KingstronSecond.vue'
import Contact from './views/Contact.vue'
import ContactSecond from './views/ContactSecond.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'index',
  },
  {
    path: '/index',
    name: 'index',
    component: Index
  },
  {
    path: '/home',
    name: 'home',
    component: Home
  },
  {
    path: '/product',
    name: 'product',
    component: Product
  },
  {
    path: '/productSecond/:mid',
    name: 'productSecond',
    component: ProductSecond
  },
  {
    path: '/information',
    name: 'information',
    component: Information
  },
  {
    path: '/informationSecond/:mid',
    name: 'informationSecond',
    component: InformationSecond
  },
  {
    path: '/kingstron',
    name: 'kingstron',
    component: Kingstron
  },
  {
    path: '/kingstronSecond/:mid',
    name: 'kingstronSecond',
    component: KingstronSecond
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  },
  {
    path: '/contactSecond/:mid',
    name: 'contactSecond',
    component: ContactSecond
  },{
	path: '/m_index/:mid/:sid',
	name: 'm_index',
	component: ()=> import('@/views/mobile/index.vue')
  }, {
	  path:"/",
	  redirect:"/home"
  }
]
// const originalPush = VueRouter.prototype.push

// VueRouter.prototype.push = function push(location) {

//   return originalPush.call(this, location).catch(err => err)

// }

const router = new Router({
  routes
})

export default router
